<template>
  <div>
    <div class="chip-container" :class="readonly ? 'readonly' : 'cursor-pointer'" @click="onClickOpenPopup">
      <div class="chips">
        <vs-chip v-for="chip in chips" :key="chip.id" color="#7E72F2" class="chip m-0">
          {{ chip.name }}
        </vs-chip>
      </div>
      <div class="popup-icon">
        <feather-icon icon="UsersIcon" />
      </div>
    </div>
    <vs-popup title="사용자 검색" :active.sync="showPopup" id="alertUserSelectPopup">
      <search-nav @handleSearch="handleSearch">
        <search-select label="검색조건" :options="{ items: searchTypes, default: 'name' }" v-model="search.type" />
        <search-keyword label="키워드" v-model="search.keyword" :onClickSearch="handleSearch" />
      </search-nav>
      <div>
        <table>
          <colgroup>
            <col width="40" />
          </colgroup>
          <thead>
          <th><vs-checkbox :value="allCheck" @click.native="onClickAllCheck" /></th>
          <th>{{ feildTitle }}</th>
          <th>소속명</th>
          <th>부서명</th>
          <th v-if="isPartName">파트명</th>
          <th>이름</th>
          </thead>
          <tbody>
          <tr v-for="user in userList" :key="user.id" :class="user.disabled ? 'disabled' : ''" @click="onClickRow(user)">
            <td @click.stop><vs-checkbox v-model="checkIds" :vs-value="user.id" :disabled="user.disabled" @change="(e) => onChangeCheckbox(e, user)" /></td>
            <td>{{ getFieldName(user.fields) }}</td>
            <td>{{ !!user.company ? user.company.com_name : "-" }}</td>
            <td>{{ user.section || "-" }}</td>
            <td v-if="isPartName">{{ user.department || "-" }}</td>
            <td>{{ `${user.name}${user.rank ? ' ' + user.rank : ''} (${user.username})` }}</td>
          </tr>
          </tbody>
        </table>
        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage" />
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end mt-4">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
        <vs-button color="secondary" @click="handleClickSelect">선택</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import KPagination from "@/components/kPagination/kPagination";

import config from "/public/config";
import SearchSelect from "@/views/list/components/SearchSelect.vue";
import SearchKeyword from "@/views/list/components/SearchKeyword.vue";

import moment from "moment";

export default {
  name: "AlertUserSelector",
  components: {
    SearchKeyword,
    SearchSelect,
    SearchNav,
    KPagination,
  },
  props: {
    fullData: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    /**
     * disabledUserIds
     * 체크박스 상태 :	비활성화 (선택 불가)
     * 결과에서 포함 여부 :	포함되지 않음
     * 사용자 수정 가능 여부 : 선택 및 해제가 불가능
     */
    disabledUserIds: { type: Array, default: () => [] },
    /**
     * disabledCheckUserIds
     * disabled(선택못하는 데이터)여도 데이터가 남아있어야할때 845
     * 체크박스 상태 :	비활성화 (선택 불가, 선택된 상태 유지)
     * 결과에서 포함 여부 :	항상 포함됨
     * 사용자 수정 가능 여부 : 선택 및 해제가 불가능
     */
    disabledCheckUserIds: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    customLoadList: Function,
    additionalData: { type: Array, default: () => [] },
    // WorkerList : WorkerList*.vue에서 사용할때
    type: String,
    isPartName: { type: Boolean, default: false },
  },
  data() {
    return {
      showPopup: false,
      checkIds: this.value.map((v) => v.id),
      checkData: this.value,
      chips: this.value,
      search: { type: "", keyword: "" },
      page: { current: 1, lastPage: 1, perPage: 5 },
      userList: [],
    };
  },
  computed: {
    allCheck() {
      if (0 < this.userList.length) {
        return this.userList.reduce((_prev, _ul) => {
          if (_ul.disabled) return _prev;
          else return _prev && this.checkIds.includes(_ul.id);
        }, true);
      } else return false;
    },
    feildTitle() {
      let _fieldTitle = "사업장명";
      switch (config.HOST_NAME) {
      case "nhsafe.maot.co.kr":
      case "dev-nhsafe.maot.co.kr":
        _fieldTitle = "현장명";
        break;
      }
      return _fieldTitle;
    },
    searchTypes() {
      return [
        { value: "field", text: this.feildTitle },
        { value: "company", text: "소속명" },
        { value: "section", text: "부서명" },
        { value: "name", text: "이름" },
        { value: "username", text: "아이디" },
        // { value: "position", text: "파트명" },
      ];
    },
  },
  watch: {
    value: {
      handler(value) {
        this.chips = value;
      },
    },
    chips: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    showPopup(value) {
      if (value) {
        this.checkIds = this.value.map((_user) => _user.id);
        this.checkData = this.checkData.filter((_user) => {
          return this.checkIds.includes(_user.id);
        });

        this.page = { current: 1, lastPage: 1, perPage: 5 };
        this.search = { type: "", keyword: "" };
        this.loadUsers();
      }
    },
  },
  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },
  methods: {
    onClickOpenPopup() {
      if (this.readonly) return;
      this.showPopup = true;
    },
    handleSearch() {
      if (!!this.search.type || !!this.search.keyword) {
        this.page = { current: 1, lastPage: 1, perPage: 5 };
        this.loadUsers();
      }
    },
    async loadUsers() {
      if (!this.showPopup) return;

      let _users = [];

      // ========= PROPS customLoadList 가 존재할때 =========
      if (this.customLoadList) {
        const { list, lastPage } = await this.customLoadList(this.page, this.search);

        _users = list;
        this.page.lastPage = lastPage;
      } else {
        // ========= 기본 =========
        const { current, lastPage, perPage } = this.page;
        const { type, keyword } = this.search;

        const params = { searchType: "and", page: current, perPage, projectId: this.$route.params.proj_id };
        switch (type) {
          case "field":
            params.field = keyword;
            break;
          case "company":
            params.company = keyword;
            break;
          case "section":
            params.section = keyword;
            break;
          case "name":
            params.name = keyword;
            break;
          case "username":
            params.username = keyword;
            break;
          case "position":
            const metaConditions = [];
            metaConditions.push({key: '직책', operator: 'LIKE', value: `%${keyword}%`})
            params.metaConditions = metaConditions;
            break;
        }

        await this.$store.dispatch("member/LOAD_MEMBERS", params);

        const listInfo = this.$store.state.member.listInfo;
        this.page.lastPage = listInfo.last_page;

        if (!this.showPopup) return [];

        _users = this.$store.state.member.list;
      }

      this.userList = _users.reduce((prev, curr) => {
        // 유저정보의 metas "안전교육 만료일" 미입력 또는 기간이 만료되었을 시 true
        let disabledSafeEduExpiryDate = false;
        if (this.type === "WorkerList") {
          let safeEduExpiryDate = "";
          curr.metas.map((meta) => {
            if (meta.meta_key === "안전교육만료일") safeEduExpiryDate = meta.meta_value;
          });

          if (!safeEduExpiryDate || moment().isAfter(moment(safeEduExpiryDate, "YYYY-MM-DD"))) {
            disabledSafeEduExpiryDate = true;
          }
        }

        const user = { ...curr, disabled: this.disabledUserIds.includes(curr.id) || this.disabledCheckUserIds.includes(curr.id) || disabledSafeEduExpiryDate };
        return [...prev, user];
      }, []);
    },
    handleChangePage(page) {
      this.page.current = page;
      this.loadUsers();
    },
    onClickAllCheck() {
      const disabledIds = this.disabledCheckUserIds; // **disabledCheckUserIds를 사용**
      const listIds = this.userList
        .filter((ul) => !ul.disabled) // **disabled 상태 제외**
        .map((ul) => ul.id);

      if (this.allCheck) {
        this.checkData = this.checkData.filter(
          (cd) => !listIds.includes(cd.id) || disabledIds.includes(cd.id) // **disabledCheckUserIds에 포함된 ID는 유지**
        );
        this.checkIds = this.checkData.map((cd) => cd.id);
      } else {
        const clean = this.checkData.filter((cd) => disabledIds.includes(cd.id)); // **항상 disabledCheckUserIds 데이터 유지**
        const newData = this.userList
          .filter((ul) => !ul.disabled) // **disabled 상태 제외**
          .map((ul) => {
            if (this.fullData) return ul;
            const result = { id: ul.id, name: ul.name };

            if (this.additionalData.length > 0) {
              for (const key of this.additionalData) {
                result[key] = ul[key];
              }
            }

            return result;
          });

        const _checkData = [...this.checkData, ...clean, ...newData];

        // id를 기준으로 중복 제거
        const uniqueData = Array.from(new Map(_checkData.map((item) => [item.id, item])).values());

        this.checkData = uniqueData;
        this.checkIds = this.checkData.map((cd) => cd.id);
      }
    },
    onClickRow(user) {
      if (user.disabled) return;

      const isChecked = this.checkIds.includes(user.id);
      if (isChecked) {
        this.checkIds = this.checkIds.filter(id => id !== user.id);
        if (!this.disabledCheckUserIds.includes(user.id)) {
          this.checkData = this.checkData.filter(cd => cd.id !== user.id);
        }
      } else {
        this.checkIds.push(user.id);
        if (this.fullData) {
          this.checkData.push(user);
        } else {
          const item = { id: user.id, name: user.name };
          if (this.additionalData.length > 0) {
            for (const key of this.additionalData) {
              item[key] = user[key];
            }
          }
          this.checkData.push(item);
        }
      }
    },
    onChangeCheckbox(e, data) {
      if (e.includes(data.id)) {
        if (this.fullData) this.checkData.push(data);
        else {
          const item = { id: data.id, name: data.name };
          if (this.additionalData.length > 0) {
            for (const key of this.additionalData) {
              item[key] = data[key];
            }
          }
          this.checkData.push(item);
        }
      } else if (!this.disabledCheckUserIds.includes(data.id)) {
        this.checkData = this.checkData.filter((cd) => cd.id !== data.id);
      }
    },
    handleClickClose() {
      this.checkData = this.chips;
      this.checkIds = this.chips.map((_c) => _c.id);
      this.showPopup = false;
    },
    handleClickSelect() {
      const _chips = this.chips.filter((ch) => {
        return this.disabledCheckUserIds.includes(ch.id);
      });
      this.chips = [..._chips, ...this.checkData];
      this.showPopup = false;
      this.$emit("select", this.chips);
    },
    removeChip(data) {
      if (!this.disabledCheckUserIds.includes(data.id)) {
        this.chips = this.chips.filter((chip) => chip.id !== data.id);
        this.checkData = this.chips;
        this.checkIds = this.chips.map((_c) => _c.id);
      }
    },
    getFieldName(fields) {
      if (fields) {
        const names = fields.map((_f) => _f.field_name);
        return names.join(", ");
      } else return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.chip-container {
  width: 100%;
  min-height: 40px;

  display: flex;
  justify-content: space-between;

  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 5px;

  padding: 6px 10px;

  &.readonly {
    background: #fafafa;
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 4px;

    .chip::v-deep {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      border-radius: 4px;
      .btn-close {
        background: none;
        i {
          font-size: 8px;
        }
      }
    }
  }

  .popup-icon {
    min-height: 100%;
    display: flex;
    border-left: solid 1px #cdcdcd;
    padding-left: 10px;
    user-select: none;
    cursor: pointer;
  }
}

#alertUserSelectPopup::v-deep {
  .vs-popup {
    width: 90%;
  }

  @media screen and (min-width: theme("screens.xl")) {
    .vs-popup {
      width: 70%;
    }
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 2px solid #f9f9f9;

  th,
  td {
    font-size: 14px;
    text-align: center;

    padding: 10px;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  thead,
  tr {
    th:first-child,
    td:first-child {
      padding: 10px 0;
    }
  }

  tbody {
    tr:nth-child(2n -1) {
      background: #f9f9f9;
    }

    tr:not(.disabled) {
      cursor: pointer;

      &:hover {
        background-color: #eef3ff;
        transition: background-color 0.2s ease;
      }
    }
  }

  tr.disabled {
    color: #d3d3d3;
  }
}
</style>
